import { httpClient } from "../http-client";
import type {
  WithdrawalRequest,
  WithdrawalRequestStatus,
} from "../../../domain/types/withdrawal";

interface Envelope<T> {
  data: T;
  errorMsg: string | null;
  errorCode: string | null;
}

export interface WithdrawalRequestPage {
  items: WithdrawalRequest[];
}

/**
 * 어드민 "운영 종료 예약 현황" 화면 전용 API.
 *
 * 승인 단계는 없다. 회사가 신청하면 바로 예약되고 7일 뒤 실행되며,
 * POD24 관리자는 현황을 보고 필요할 때 예약을 취소할 수 있다.
 */
export class AdminWithdrawalApiService {
  async list(params: {
    status?: WithdrawalRequestStatus | null;
    keyword?: string | null;
    page?: number;
    size?: number;
  }): Promise<WithdrawalRequestPage> {
    const query = new URLSearchParams();
    if (params.status) query.append("status", params.status);
    if (params.keyword) query.append("keyword", params.keyword);
    if (params.page !== undefined) query.append("page", String(params.page));
    if (params.size !== undefined) query.append("size", String(params.size));

    const response = await httpClient.get<Envelope<WithdrawalRequestPage>>(
      `/api/admin/withdrawal/requests?${query.toString()}`
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "신청 목록을 가져오지 못했습니다."
      );
    }

    return response.data.data;
  }

  /** 예약 취소 — 예정일이 지나 삭제가 실행되면 되돌릴 수 없다. */
  async cancel(requestId: number): Promise<WithdrawalRequest> {
    const response = await httpClient.put<Envelope<WithdrawalRequest>>(
      `/api/admin/withdrawal/requests/${requestId}/cancel`,
      {}
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "취소에 실패했습니다.");
    }

    return response.data.data;
  }
}

export const adminWithdrawalApiService = new AdminWithdrawalApiService();
